import { DataTable } from '@pihealth/common-ui-library';
import React, { useEffect, useState } from 'react';
import staticData from '../../../resources/static.json';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setSelectedformData, setShowCMPArr } from 'src/store/feasibility';
import { useGetAllFeasibilityMutation } from 'src/services/feasibility';
import { useUtil } from 'src/components/hooks/useUtil';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';

const FeasibilityTable: React.FunctionComponent<any> = () => {
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { handleError } = useUtil();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector((state: any) => state.site.selectedCountry);
  const selectedSite = useAppSelector((state: any) => state.site.selectedSite);
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<any>([]);
  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [filterObject, setFilterObject] = useState<any>();
  const formClick = (rowData: any) => {
    dispatch(setSelectedformData(rowData));
    dispatch(setShowCMPArr('feasibilityForm'));
  };
  const actions = {
    name: (data: any) => {
      formClick(data);
    }
  };
  const [
    getAllFeasibility,
    {
      data: getAllFeasibilityData,
      isError: getAllFeasibilityisError,
      error: getAllFeasibilityError,
      isLoading: getAllFeasibilityIsLoading
    }
  ] = useGetAllFeasibilityMutation();
  const getAllFeasibilityFunc = (from: number, size: number) => {
    getAllFeasibility({
      site_id: selectedSite,
      study_id: studyId,
      data: filterObject,
      country: selectedCountry,
      application: 'TSDA',
      from,
      size
    });
  };

  useEffect(() => {
    if (pageSize === 10 || pageSize === 20 || pageSize === 30) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getAllFeasibilityFunc(0, pageSize);
      } else {
        getAllFeasibilityFunc(pageNumber * pageSize, pageSize);
      }
    }
  }, [pageNumber, pageSize, selectedSite, studyId, selectedCountry, filterObject]);

  useEffect(() => {
    if (getAllFeasibilityData) {
      setRowsCount(getAllFeasibilityData?.record_count);
      setRows(
        getAllFeasibilityData?.selected_data.map((ele: any) => {
          return { ...ele, updated_on: ele.updated_on ?? ele.created_on, updated_by: ele.updated_by ?? ele.created_by };
        })
      );
    }
  }, [getAllFeasibilityData]);

  useEffect(() => {
    if (getAllFeasibilityisError) {
      handleError(getAllFeasibilityError);
      setRowsCount(0);
      setPageNumber(0);
      setRows([]);
    }
  }, [getAllFeasibilityisError]);

  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${staticData.FeasibilityTable.file_export_name} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };

  const dataTableProps = {
    filtermode: 'server'
  };

  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  return (
    <DataTable
      dataTableProps={dataTableProps}
      rows={rows}
      columns={staticData.FeasibilityTable.dataTablecolumns}
      datePreference={userPreferedDateFormat}
      actions={actions}
      loading={getAllFeasibilityIsLoading}
      paging
      pageSize={pageSize}
      setPageSize={setPageSize}
      rowsCount={rowsCount}
      pageNumber={pageNumber}
      setPageNumber={setPageNumber}
      paginationMode="server"
      hasDefinedDataGridToolbarExport
      definedGridToolbarExport={definedCustomDatGridExport}
      filterValues={(data: any) => filterValues(data)}
      height="84vh"
    />
  );
};
export default FeasibilityTable;
